import { isSeatFirstOrderingForShowtime } from '../../../browsing/selectors/showtimes/is-seat-first-ordering-for-showtime';
import { getOrderSeatCountForAreaCategory } from '../seats/get-order-seat-count-for-area-category';
import { getAllowedOrderTicketCountForShowtime } from './get-allowed-order-ticket-count-for-showtime';
export const getAllowedOrderTicketCountForAreaCategory = (showtimeId, areaCategoryId) => {
    return isSeatFirstOrderingForShowtime(showtimeId)
        ? getOrderSeatCountForAreaCategory(showtimeId, areaCategoryId)
        : getAllowedOrderTicketCountForShowtime(showtimeId);
};
